import React from 'react';
import { supabaseLocationService } from '../../services/supabaseLocationService';
import { FeaturedToolsSection } from './FeaturedToolsSection';
import { GhgInventorySection } from './GhgInventorySection';
import { HomeHero } from './HomeHero';
import { MembershipFinalCtaSection } from './MembershipFinalCtaSection';
import { PublicVsMembershipSection } from './PublicVsMembershipSection';
import { SuccessStoriesSection } from './SuccessStoriesSection';
import { WhyCoolClimateSection } from './WhyCoolClimateSection';
import './HomePage.css';

export interface HomePageProps {
  onLocationSelect: (location: string) => void;
  citiesCount: number;
  countiesCount: number;
  communitiesCount: number;
  loading?: boolean;
}

export const HomePage: React.FC<HomePageProps> = ({
  onLocationSelect,
  citiesCount,
  countiesCount,
  communitiesCount,
  loading = false,
}) => (
  <div className="overview-page home-page">
    <HomeHero
      onLocationSelect={onLocationSelect}
      citiesCount={citiesCount}
      countiesCount={countiesCount}
      communitiesCount={communitiesCount}
      showDevHint={!loading && citiesCount === 0 && countiesCount === 0}
    />

    <GhgInventorySection />
    <PublicVsMembershipSection />
    <FeaturedToolsSection />
    <WhyCoolClimateSection />
    <SuccessStoriesSection />
    <MembershipFinalCtaSection />

    {supabaseLocationService.isDevFallback() && (
      <p className="home-page__dev-fallback">
        Not connected to database. Copy <code>.env.example</code> to <code>.env</code> in{' '}
        <code>my-app/frontend</code> and add your Supabase URL and anon key to load full location data.
      </p>
    )}
  </div>
);

export default HomePage;
